import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/AppointmentForm.css";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from 'react-i18next';

function AppointmentForm() {
  const { t, i18n } = useTranslation();
  const [isRTL, setIsRTL] = useState(i18n.language === 'he');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    i18n.on('languageChanged', (lng) => setIsRTL(lng === 'he'));
  }, [i18n]);

  const [patientName, setPatientName] = useState("");
  const [patientNumber, setPatientNumber] = useState("");
  const [patientGender, setPatientGender] = useState("default");
  const [appointmentTime, setAppointmentTime] = useState("");
  const [preferredMode, setPreferredMode] = useState("default");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    const errors = {};
    if (!patientName.trim()) {
      errors.patientName = t("patientNameRequired");
    } else if (patientName.trim().length < 8) {
      errors.patientName = t("patientNameLength");
    }

    if (!patientNumber.trim()) {
      errors.patientNumber = t("patientPhoneRequired");
    } else if (patientNumber.trim().length !== 10) {
      errors.patientNumber = t("patientPhoneLength");
    }

    if (patientGender === "default") {
      errors.patientGender = t("selectGender");
    }
    if (!appointmentTime) {
      errors.appointmentTime = t("appointmentTimeRequired");
    } else {
      const selectedTime = new Date(appointmentTime).getTime();
      const currentTime = new Date().getTime();
      if (selectedTime <= currentTime) {
        errors.appointmentTime = t("selectFutureTime");
      }
    }
    if (preferredMode === "default") {
      errors.preferredMode = t("selectMode");
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    // Prepare WhatsApp message
    const phoneNumber = "+972507171982";
    const message = encodeURIComponent(
      `${t("appointmentDetails")}\n\n${t("patientName")}: ${patientName}\n${t("patientPhone")}: ${patientNumber}\n${t("gender")}: ${patientGender}\n${t("appointmentTime")}: ${appointmentTime}\n${t("preferredMode")}: ${preferredMode}`
    );

    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");

    // Reset form fields and errors after successful submission
    setPatientName("");
    setPatientNumber("");
    setPatientGender("default");
    setAppointmentTime("");
    setPreferredMode("default");
    setFormErrors({});

    toast.success(t("appointmentScheduled"), {
      position: toast.POSITION.TOP_CENTER,
      onOpen: () => setIsSubmitted(true),
      onClose: () => setIsSubmitted(false),
    });
  };

  return (
    <div className={`appointment-form-section ${isRTL ? 'rtl' : ''}`}>
      <h1 className="legal-siteTitle">
        <Link to="/">
          Dr.Shada <span className="navbar-sign">Habib</span>
        </Link>
      </h1>

      <div className="form-container">
        <h2 className="form-title">
          <span>{t("bookAppointmentOnline")}</span>
        </h2>

        <form className="form-content" onSubmit={handleSubmit}>
          <label>
            {t("patientFullName")}:
            <input
              type="text"
              value={patientName}
              onChange={(e) => setPatientName(e.target.value)}
              required
            />
            {formErrors.patientName && <p className="error-message">{formErrors.patientName}</p>}
          </label>

          <br />
          <label>
            {t("patientPhoneNumber")}:
            <input
              type="text"
              value={patientNumber}
              onChange={(e) => setPatientNumber(e.target.value)}
              required
            />
            {formErrors.patientNumber && <p className="error-message">{formErrors.patientNumber}</p>}
          </label>

          <br />
          <label>
            {t("patientGender")}:
            <select
              value={patientGender}
              onChange={(e) => setPatientGender(e.target.value)}
              required
            >
              <option value="default">{t("select")}</option>
              <option value="male">{t("male")}</option>
              <option value="female">{t("female")}</option>
              <option value="private">{t("informDoctor")}</option>
            </select>
            {formErrors.patientGender && <p className="error-message">{formErrors.patientGender}</p>}
          </label>

          <br />
          <label>
            {t("preferredAppointmentTime")}:
            <input
              type="datetime-local"
              value={appointmentTime}
              onChange={(e) => setAppointmentTime(e.target.value)}
              required
            />
            {formErrors.appointmentTime && <p className="error-message">{formErrors.appointmentTime}</p>}
          </label>

          <br />
          <label>
            {t("preferredMode")}:
            <select
              value={preferredMode}
              onChange={(e) => setPreferredMode(e.target.value)}
              required
            >
              <option value="default">{t("select")}</option>
              <option value="voice">{t("voiceCall")}</option>
              <option value="video">{t("videoCall")}</option>
              <option value="meeting">{t("meeting")}</option>
            </select>
            {formErrors.preferredMode && <p className="error-message">{formErrors.preferredMode}</p>}
          </label>

          <br />
          <button type="submit" className="text-appointment-btn">
            {t("confirmAppointment")}
          </button>

          <p className="success-message" style={{ display: isSubmitted ? "block" : "none" }}>
            {t("appointmentSent")}
          </p>
        </form>
      </div>
      <ToastContainer
        autoClose={5000}
        limit={1}
        closeButton={false}
        style={{ width: "100px", fontSize: "10px" }} // Adjust width and font size
      />
      <div className="legal-footer">
        <p>&copy; 2024 R & R-Net. All rights reserved.</p>
      </div>

    </div>
  );
}

export default AppointmentForm;
